import { HTML } from 'https://cdn.jsdelivr.net/gh/deco-sites/std@1.21.7/components/types.ts'
import RenderHTML from 'site/components/ui/RenderHTML.tsx'
import { CouponCardProps } from './CouponCard.tsx'
import CouponCard from './CouponCard.tsx'

export interface Props {
    /**
     * @title Título
     */
    title?: string
    /**
     * @title Lista de cupons
     */
    coupons: CouponCardProps[]
    /**
     * @title Informações adicionais
     */
    content?: HTML
}

function CouponsGallery({ coupons, title, content }: Props) {
    return (
        <div class='max-w-[1222px] w-full mx-auto px-5 xl:px-0'>
            {title && (
                <h2 class='text-[32px] text-center lg:text-start font-extrabold text-neutral-0 pt-8 pb-4 border-b border-neutral-4 mb-8'>
                    {title}
                </h2>
            )}

            <div class='flex flex-col self-center max-w-[1222px] items-center gap-x-[7px] gap-y-[7px] lg:gap-y-[22px] sm:flex-row sm:flex-wrap sm:justify-center xl:justify-around '>
                {coupons?.map((coupon) => <CouponCard {...coupon} />)}
            </div>
            <div class='my-14 font-lato text-sm text-neutral-1'>
                {content && <RenderHTML html={content} />}
            </div>
        </div>
    )
}

export default CouponsGallery
